import React from 'react';
import { Link } from 'react-router-dom';
import { shipmentStatusLabel, shipmentStatusBadgeClass, shipmentStatusOptions } from './incomingShipmentStatusUi';
import IncomingStatusBadgePicker from './IncomingStatusBadgePicker';

const IncomingShipmentsMobileView = ({
  shipments,
  newName,
  setNewName,
  createShipment,
  creating,
  busy = false,
  loading,
  error,
  savingShipmentStatusId,
  onPatchShipmentStatus,
  deletingShipmentId,
  onDeleteShipment
}) => {
  return (
    <>
      <div className='row mt-3'>
        <div className='col-12'>
          <h3 className='font-weight-bold'>Надходження</h3>
        </div>
      </div>

      <div className='row mb-3'>
        <div className='col-12'>
          <input
            type='text'
            className='form-control'
            placeholder='Назва надходження'
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && createShipment()}
            disabled={busy || creating}
          />
          <button className='btn btn-dark btn-block mt-2' onClick={createShipment} disabled={busy || creating || !newName.trim()}>
            {creating ? 'Створення...' : 'Створити нове надходження'}
          </button>
        </div>
      </div>

      {error ? <div className='alert alert-danger'>{error}</div> : null}

      {loading ? (
        <div>Завантаження...</div>
      ) : (
        <div className='row'>
          <div className='col-12'>
            {(shipments || []).map((r) => (
              <div className='card mb-2' key={r.id}>
                <div className='card-body py-2 px-3'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <div>
                      <div className='font-weight-bold'>#{r.id} — {r.name}</div>
                      <div className='text-muted small'>{r.createdAt ? new Date(r.createdAt).toLocaleString('uk-UA') : '-'}</div>
                      <div className='small mt-1 d-flex flex-wrap align-items-center' style={{ gap: '0.35rem' }}>
                        <span className='text-muted mb-0'>Статус</span>
                        <IncomingStatusBadgePicker
                          value={r.status || 'draft'}
                          options={shipmentStatusOptions(r.status)}
                          labelOf={shipmentStatusLabel}
                          badgeClassOf={shipmentStatusBadgeClass}
                          onPick={(next) => onPatchShipmentStatus(r.id, next)}
                          disabled={busy || savingShipmentStatusId != null || deletingShipmentId != null || !onPatchShipmentStatus}
                          title='Статус поставки — натисніть, щоб змінити'
                        />
                      </div>
                      <div className='small'>Сканів: {r.itemsCount ?? 0}</div>
                    </div>
                    <div className='d-flex flex-column ml-2'>
                      <Link to={`/admin/incoming-shipments/${r.id}`} className='btn btn-sm btn-outline-dark'>Відкрити</Link>
                      {r.canDelete && <button type='button' className='btn btn-sm btn-outline-danger mt-2'
                        disabled={busy || deletingShipmentId != null || savingShipmentStatusId != null || !onDeleteShipment}
                        onClick={() => onDeleteShipment(r)} aria-label={`Видалити поставку #${r.id}`}>
                        {deletingShipmentId === r.id ? 'Видалення…' : 'Видалити'}
                      </button>}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {!shipments.length ? (
              <div className='text-muted'>Надходжень ще немає</div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};

export default IncomingShipmentsMobileView;
